import { selectIsLoading, selectIsLoggedIn } from 'containers/Login/loginSlice'
import useRedirectPath from 'hooks/useRedirectPath'
import { Redirect, Route } from 'react-router-dom'
import BottomBar from 'components/BottomBar'
import { useSelector } from 'react-redux'
import Loading from 'components/Loading'
import Header from 'containers/Header'

const MRoute = ({ path, showNotification = false, darkHeader = false, whiteHeader = false, roundedHeader = false, flyingHeader = false, animation = true, bottomBar = false, protectedPath = false, isHeader: _isHeader = true, showHeaderOnlyIfUserIsLogIn = false, children }) => {
  const isLoggedIn = useSelector(selectIsLoggedIn)
  const isLoading = useSelector(selectIsLoading)
  const isHeader = _isHeader || (showHeaderOnlyIfUserIsLogIn ? !!isLoggedIn : false)
  useRedirectPath(protectedPath)

  return (
    (protectedPath && !isLoggedIn)
      ? isLoading
        ? <main>
          <Loading middleOfPage />
        </main>
        : <Redirect to='/login' />
      : <Route path={path}>
        {isHeader && <Header
          dark={darkHeader}
          white={whiteHeader}
          flying={flyingHeader}
          rounded={roundedHeader}
          showNotification={showNotification}
        />}
        <main className={animation ? ' --animated' : undefined}>
          {children}
        </main>
        {bottomBar && <BottomBar />}
      </Route>
  )
}

export default MRoute